export default __webpack_public_path__ + "static/media/how-it-3.ce5a0014.png";